import { CertificatePaymentModel } from '../types'

const deleteNullKeys = (val: object | null | undefined) => {
  if (val && typeof val === 'object') {
    for (const key in val) {
      if (val[key as keyof Object]) {
        deleteNullKeys(val[key as keyof Object])
        if (!Object.keys(val[key as keyof Object]).length) {
          delete val[key as keyof Object]
        }
      } else {
        delete val[key as keyof Object]
      }
    }
  }
}

type DateFormat = 'DMY' | 'YMD'

const dateOrder: Record<DateFormat, [number, number, number]> = {
  DMY: [0, 1, 2],
  YMD: [2, 1, 0],
}

const orderDateParts = (
  parts: [string, string, string],
  format: DateFormat
) => {
  const order = dateOrder[format]
  return [parts[order[0]], parts[order[1]], parts[order[2]]]
}

const getFormattedDate = (date: string, order: DateFormat = 'YMD') => {
  const regex = /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.\d{4}$/
  if (!regex.test(date)) return null
  const [day, month, year] = date.split('.')
  const [first, second, third] = orderDateParts([day, month, year], order)
  return `${first}-${second}-${third}`
}

export default function submitAdapter(
  payload: CertificatePaymentModel
): FormData {
  const {
    serial,
    number,
    dateContract,
    name,
    surname,
    patronymic,
    hasPatronymic,
    birthday,
    inn,
    passport,
    passportDate,
    email,
    phone,
    isInsured,
    documents,
    typeGettingDocuments,
    insuredName,
    insuredSurname,
    insuredPatronymic,
    hasInsuredPatronymic,
    insuredBirthday,
    insuredInn,
    insuredPassport,
    insuredPassportDate,
    previousRequest,
    reportingYear,
    amountPaidInsurance,
    countTaxRequests,
  } = payload

  const fieldsToSubmit = {
    outCall: {
      description: null,
      sourceGUID: previousRequest || null,
    },
    service: {
      code: '33f7eb60-b928-4886-9d13-6d1c7a7d2556',
    },
    category: {
      code: '8b6b8818-6edd-4a1e-adec-e521ca72b566',
    },
    email,
    certificatePayment: {
      certificateType: 'Справка об уплате страховых взносов',
      payerLastName: surname,
      payerMiddleName: hasPatronymic ? patronymic : null,
      payerFirstName: name,
      payerBirthday: getFormattedDate(birthday, 'DMY'),
      payerInn: inn,
      payerPassport: passport,
      payerPassportDate: getFormattedDate(passportDate),
      payerPhone: phone,
      payerPolicyDate: getFormattedDate(dateContract, 'DMY'),
      payerPolicyNumber: number,
      payerPolicySeries: serial,
      isInsuredPerson: isInsured.toString(),
      insuredPersonLastName: insuredSurname || null,
      insuredPersonMiddleName: hasInsuredPatronymic ? insuredPatronymic : null,
      insuredPersonFirstName: insuredName || null,
      insuredPersonBirthday: getFormattedDate(insuredBirthday, 'DMY') || null,
      insuredPersonInn: insuredInn || null,
      insuredPersonPassport: insuredPassport || null,
      insuredPersonPassportDate: getFormattedDate(insuredPassportDate) || null,
      reportingYear: reportingYear || null,
      typeGettingDocuments,
      amountPaidInsurance: amountPaidInsurance || '0',
      countTaxRequests: countTaxRequests || '0',
    },
    region: {
      code: '-',
      title: '-',
      client: {
        cityPhoneNumber: phone,
        email,
        lastName: surname,
        firstName: name,
        middleName: hasPatronymic ? patronymic : null,
      },
    },
    wayAddressing: {
      code: 'site',
    },
    facility: {
      code: 'siteMobileApp',
    },
  }
  deleteNullKeys(fieldsToSubmit)

  return { fields: fieldsToSubmit, files: documents }
}
